import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import type { Mag } from '../../../types/toppage';
import { getMagcategories } from '../../../services/toppage';

export const Component: FunctionComponent = () => {
  const [magCategories, setMagCategories] = useState<Mag[]>([]);
  const [activeTab, setActiveTab] = useState<number>(0);

  useEffect(() => {
    const request = async () => {
      try {
        const data = await getMagcategories();
        setMagCategories(data);
        if (data.length > 0) {
          setActiveTab(data[0].id);
        }
      } catch (error) {
        console.error(error);
      }
    };
    request();
  }, []);

  return (
    <Presentation
      magCategories={magCategories}
      activeTab={activeTab}
      onTabChange={setActiveTab}
    />
  );
};
